<template>
    <!-- 결제사에서 이미 환불된 주문을 환불 호출 없이 취소완료로 바꾸는 다이얼로그. 성공하면 바뀐 주문과 고른 값({ voidPins })을 cancel-marked 로 올리고, 주문 교체·목록 재조회·알림은 부모가 한다. -->
    <v-dialog v-model="shows" width="520" :persistent="loading">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>

        <v-card light v-bind="{ loading }">
            <v-card-title>
                취소표기
                <v-spacer />
                <v-icon :disabled="loading" @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text class="pt-4 body-2">
                <div>결제사에서 이미 환불된 주문을 취소완료로 바꿉니다.</div>
                <ul class="mt-2">
                    <li>결제사 환불은 다시 부르지 않습니다.</li>
                    <li>표기한 주문은 결제일 매출에서 빠집니다. 지난 기간 매출 숫자도 바뀝니다.</li>
                    <li class="error--text">되돌릴 수 없습니다.</li>
                </ul>

                <v-radio-group v-model="voidPins" :disabled="loading" hide-details class="mt-4">
                    <v-radio :value="false">
                        <template #label>
                            <div>
                                <div>상태만 바꾸기</div>
                                <div class="caption grey--text">핀은 그대로 둡니다. 아직 살아 있는 핀은 고객이 핀번호로 계속 충전할 수 있습니다. (나누리핀에서 이미 폐기된 핀은 해당 없음)</div>
                            </div>
                        </template>
                    </v-radio>
                    <v-radio :value="true" :disabled="!ungainedCount" class="mt-2">
                        <template #label>
                            <div>
                                <div>핀도 폐기하기</div>
                                <div v-if="ungainedCount" class="caption grey--text">충전하지 않은 핀 {{ ungainedCount }}장 중 나누리핀에서 아직 사용·폐기되지 않은 핀만 폐기합니다. 이미 폐기된 핀은 건너뜁니다. 실제로 폐기한 핀만 나누리핀 정산이 되돌려집니다.</div>
                                <div v-else class="caption grey--text">충전하지 않은 핀이 없습니다.</div>
                            </div>
                        </template>
                    </v-radio>
                </v-radio-group>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn text :disabled="loading" @click="shows = false"> 닫기 </v-btn>
                <v-btn color="error" :loading="loading" @click="submit"> 취소표기 </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";

export default {
    props: {
        order: { type: Object, default: () => ({}) },
    },
    data: () => ({
        shows: false,
        loading: false,

        voidPins: false,
    }),
    computed: {
        ungainedCount() {
            return (this.order?.pins || []).filter((pin) => !pin?.isGained).length;
        },
    },
    watch: {
        // 열 때마다 기본값(상태만 바꾸기)으로 되돌린다.
        shows() {
            if (this.shows) this.voidPins = false;
        },
    },
    methods: {
        async submit() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { order } = await api.console.nshop.orders.cancelMark.post({ _id: this.order._id, voidPins: this.voidPins });
                this.shows = false;
                this.$emit("cancel-marked", order, { voidPins: this.voidPins });
            } catch (error) {
                alert(error?.response?.data?.message || error.message);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
